import type { FlowStep } from '@/data'
import type { BrandingEditorConfig } from '../../BrandingEditor'

export const defaultSteps: FlowStep[] = []

// Custom keys mirror the cobranded chat config shape so brand.custom can be
// passed to the chat as-is.
export const brandingConfig: BrandingEditorConfig = {
  title: 'Branding',
  miniLogo: true,
  colorFields: [
    { key: 'primary_color', label: 'Header & Footer' },
    { key: 'secondary_color', label: 'Call Now Button' },
  ],
  customColorFields: [
    {
      key: 'showFooter',
      label: 'Show Footer',
      default: false,
      type: 'toggle',
    },
    {
      key: 'showCallNowButton',
      label: 'Show Call Now Button',
      default: false,
      type: 'toggle',
    },
    {
      key: 'hideTDLogo',
      label: 'Hide TD Logo',
      default: false,
      type: 'toggle',
    },
    {
      key: 'chatHeaderTextColor',
      label: 'Chat Header Text',
      default: '#002244',
    },
    {
      key: 'backgroundColor',
      label: 'Background Gradient',
      default: '#EEEEEE',
    },
    { key: 'chatBoxBorder', label: 'Chat Box Border', default: '#002244' },
    {
      key: 'profileBackground',
      label: 'Customer Profile Background',
      default: '#002244',
    },
    {
      key: 'profileTextColor',
      label: ' Customer Profile Text',
      default: '#63CE4D',
    },
    {
      key: 'agentBackgroundColor',
      label: 'Agent Message Background',
      default: '#fafafa',
    },
    {
      key: 'agentBorderColor',
      label: 'Agent Message Border',
      default: '#002244',
    },
    { key: 'agentFontColor', label: 'Agent Message Text', default: '#4D4F53' },
    {
      key: 'customerBackgroundColor',
      label: 'Customer Message Background',
      default: '#fafafa',
    },
    {
      key: 'customerBorderColor',
      label: 'Customer Message Border',
      default: '#63CE4D',
    },
    {
      key: 'customerFontColor',
      label: 'Customer Message Text',
      default: '#4D4F53',
    },
    { key: 'textareaBorder', label: 'Input Border', default: '#000000' },
    {
      key: 'textareaBorderFocus',
      label: 'Input Border (Focus)',
      default: '#000000',
    },
    { key: 'sendButtonColor', label: 'Send Button', default: '#63CE4D' },
    {
      key: 'sendButtonBorder',
      label: 'Send Button Border',
      default: '#4D4F53',
    },
    {
      key: 'sendButtonBorderActive',
      label: 'Send Button Border (Active)',
      default: '#002244',
    },
    { key: 'lockColor', label: 'Lock', default: '#63CE4D' },
    { key: 'lockBorder', label: 'Lock Border', default: '#000000' },
  ],
}
